import { sharedLoyaltyEffects } from './loyalty.effects';
import { SharedLoginEffects } from './login.effects';

export const sharedLibEffects = [sharedLoyaltyEffects, SharedLoginEffects];
